import { GDFPalletCode } from '../gdf/type';
import { Palette } from './palettes';

export const lightning: Palette[] = [
    {
        id: GDFPalletCode.lightning_prb,
        name: 'Lightning - Probability',
        type: 'categorical',
        entries: [
            { label: 'NA', color: 'rgba(0,0,0,0)' },
            { label: '>0 – 20%', color: 'rgb(5,100,255)' },
            { label: '>20% - 40%', color: 'rgb(10,200,7)' },
            { label: '>40% - 60%', color: 'rgb(255,233,1)' },
            { label: '>60% - 80%', color: 'rgb(255,128,1)' },
            { label: '>80% – 90%', color: 'rgb(215,36,0)' },
            { label: '>90% - 100%', color: 'rgb(219,18,236)' }
        ]
    },
    {
        id: GDFPalletCode.lightning_jumpgrid,
        name: 'Lightning Jump Grid',
        type: 'categorical',
        entries: [
            { label: 'N/A', color: 'rgb(0,0,0)', hide: true },
            { label: 'N/A', color: 'rgb(81,81,81)' },
            { label: '2 sigma (standard deviation)', color: 'rgb(22,137,67)' },
            { label: '3 sigma (standard deviation)', color: 'rgb(245,208,17)' },
            { label: '4 sigma (standard deviation)', color: 'rgb(245,123,32)' },
            { label: '5 sigma (standard deviation)', color: 'rgb(229,111,171)' },
            { label: '6 sigma (standard deviation)', color: 'rgb(172,33,35)' },
            { label: '7-9 sigma (standard deviation)', color: 'rgb(177,116,245)' },
            { label: '10+ sigma (standard deviation)', color: 'rgb(128,1,241)' }
        ]
    },
    {
        id: GDFPalletCode.lightning_density,
        name: 'Lightning Density',
        type: 'categorical',
        entries: [
            { label: 'NA', color: 'rgb(0,0,0)', hide: true },
            { label: '1 flash/km²/min', color: 'rgb(171,171,171)' },
            { label: '2 flashes/km²/min', color: 'rgb(255,255,255)' },
            { label: '3-5 flashes/km²/min', color: 'rgb(10,212,7)' },
            { label: '6-10 flashes/km²/min', color: 'rgb(216,209,20)' },
            { label: '11-20 flashes/km²/min', color: 'rgb(255,169,0)' },
            { label: '21-30 flashes/km²/min', color: 'rgb(255,91,2)' },
            { label: '31-40 flashes/km²/min', color: 'rgb(190,21,2)' },
            { label: '>41 flashes/km²/min', color: 'rgb(226,14,221)' }
        ]
    },
    {
        id: GDFPalletCode.lightning1_faded,
        name: 'Lightning color coding',
        type: 'combined',
        displayType: 'categorical',
        colors: [
            'rgb(255,255,1)',
            'rgb(234,234,7)',
            'rgb(214, 214, 16)',
            'rgb(192,193,27)',
            'rgb(175,174,37)',
            'rgb(156,156,46)',
            'rgb(138,138,55)',

            'rgb(255,0,0)',
            'rgb(239, 11, 9)',
            'rgb(223,19,18)',
            'rgb(207,29,28)',
            'rgb(192,37,37)',
            'rgb(176,46,46)',
            'rgb(160,55,55)'
        ],
        values: [
            '< 2 minutes',
            '2 to < 4 minutes',
            '4 to < 6 minutes',
            '6 to < 10 minutes',
            '10 to < 15 minutes',
            '15 to < 20 minutes',
            '>= 20 minutes'
        ],
        palettes: [
            { name: 'Neg', offset: 0, length: 7 },
            { name: 'Pos', offset: 7, length: 7 }
        ]
    },
    {
        id: GDFPalletCode.lightning1_discrete,
        name: 'Lightning color coding',
        type: 'combined',
        displayType: 'categorical',
        colors: [
            'rgb(255,255,255)',
            'rgb(255,0,0)',
            'rgb(250,125,0)',
            'rgb(255,255,1)',
            'rgb(48,48,240)',
            'rgb(125,125,125)',
            'rgb(90,90,90)',

            'rgb(255,255,255)',
            'rgb(255,0,0)',
            'rgb(250,125,0)',
            'rgb(255,255,1)',
            'rgb(48,48,240)',
            'rgb(125,125,125)',
            'rgb(90,90,90)'
        ],
        values: [
            '< 2 minutes',
            '2 to < 4 minutes',
            '4 to < 6 minutes',
            '6 to < 10 minutes',
            '10 to < 15 minutes',
            '15 to < 20 minutes',
            '>= 20 minutes'
        ],
        palettes: [
            { name: 'Neg', offset: 0, length: 7 },
            { name: 'Pos', offset: 7, length: 7 }
        ]
    },
    {
        id: GDFPalletCode.lightning0_faded,
        name: 'Lightning',
        type: 'combined',
        displayType: 'categorical',
        colors: [
            'rgb(255,255,1)',
            'rgb(234,234,7)',
            'rgb(214, 214, 16)',
            'rgb(192,193,27)',
            'rgb(175,174,37)',
            'rgb(156,156,46)',
            'rgb(138,138,55)',
            'rgb(120,120,65)',

            'rgb(255,0,0)',
            'rgb(239,11,9)',
            'rgb(223, 19, 18)',
            'rgb(207,29,28)',
            'rgb(192,37,37)',
            'rgb(176,46,46)',
            'rgb(160,55,55)',
            'rgb(125,76,75)'
        ],
        values: [
            '0 to < 10 minutes',
            '10 to < 20 minutes',
            '20 to < 30 minutes',
            '30 to < 40 minutes',
            '40 to < 50 minutes',
            '50 to < 60 minutes',
            '60 to < 70 minutes',
            '>= 70 minutes'
        ],
        palettes: [
            {
                name: 'Neg',
                offset: 0,
                length: 8
            },
            {
                name: 'Pos',
                offset: 8,
                length: 8
            }
        ]
    },
    {
        id: GDFPalletCode.lightning0_discrete,
        name: 'Lightning',
        type: 'combined',
        displayType: 'categorical',
        colors: [
            'rgb(255,255,255)',
            'rgb(255,0,0)',
            'rgb(250,125,0)',
            'rgb(255,255,1)',
            'rgb(48,48,240)',
            'rgb(125,125,125)',
            'rgb(90,90,90)',
            'rgb(0,0,0)',

            'rgb(255,255,255)',
            'rgb(255,0,0)',
            'rgb(250,125,0)',
            'rgb(255,255,1)',
            'rgb(48,48,240)',
            'rgb(125,125,125)',
            'rgb(90,90,90)',
            'rgb(0,0,0)'
        ],
        values: [
            '0 to < 10 minutes',
            '10 to < 20 minutes',
            '20 to < 30 minutes',
            '30 to < 40 minutes',
            '40 to < 50 minutes',
            '50 to < 60 minutes',
            '60 to < 70 minutes',
            '>= 70 minutes'
        ],
        palettes: [
            {
                name: 'Neg',
                offset: 0,
                length: 8
            },
            {
                name: 'Pos',
                offset: 8,
                length: 8
            }
        ]
    }
];
